import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'workspace',
        url: '/workspace',
        component: 'wtWorkspaceState',
        resolve: {
            auth: Resolve.authResolve,
            license: Resolve.licenseResolve
        },
        data: {
            visible: false,
            sortingOrder: 999,
            icon: 'fa-cogs',
            displayName: 'Applications workspace',
            ignoreHistory: true,
            editRoles: [Roles.superAdministrator],
            editButtonVisibility: () => true
        }
    }];

export default states;